import {TSSerializable} from './TSSerializable';
import TSAdresse from './TSAdresse';
import TSAbstractPersonEntity from './TSAbstractPersonEntity';

export default class TSGesuchsPersonDaten extends TSAbstractPersonEntity implements TSSerializable<TSGesuchsPersonDaten> {

    private _adresse: TSAdresse | undefined;

    private _mail: string;

    private _telefon: string;

    constructor() {
        super();
        this._adresse = new TSAdresse();
    }

    public get adresse(): TSAdresse  | undefined {
        return this._adresse;
    }

    public set adresse(value: TSAdresse | undefined) {
        this._adresse = value;
    }

    public get mail(): string {
        return this._mail;
    }

    public set mail(value: string) {
        this._mail = value;
    }

    public get telefon(): string {
        return this._telefon;
    }

    public set telefon(value: string) {
        this._telefon = value;
    }

    deserialize(restObject: any): TSGesuchsPersonDaten {
        super.deserialize(restObject);
        this.mail = restObject.mail;
        this.telefon = restObject.telefon;
        this.adresse = this.deserializeOrNull(restObject.adresse , new TSAdresse);
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.mail = this.mail === '' ? null : this.mail;
        restObject.telefon = this.telefon;
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGesuchsPersonDaten.ts